import { TextField } from "app/components/CustomFormElements/syncFusionFormFields";
import { revenueValidationSchema } from "app/helper/validationSchema/companyValidationSchema";
import { useFormik } from "formik";
import * as Yup from "yup";
import { actionError, actionSuccess, showLoader, hideLoader } from "middleware/actions/utilityAction";
import { fetchSingleRevenue, fetchSingleCompany, saveRevenue, editRevenue } from "middleware/services/companyApi";
import { useEffect, useRef, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setBreadCrumb } from "middleware/actions/breadCrumbAction";
import { useHistory } from "react-router-dom";

const CompanyBasicRevenue = (props) => {
  const { companyId, revenueId } = props.computedMatch.params || {};
  const [companyName, setCompanyName] = useState("");
  const revenueYearRef = useRef();

  const [oldData, setOldData] = useState(null);
  const split_url = props.location?.pathname.split("/");

  const backPath = revenueId ? `${split_url.slice(0, -3).join("/")}/edit#basic` : `${split_url.slice(0, -2).join("/")}/edit#basic`;

  const dispatch = useDispatch();
  const history = useHistory();

  const breadCrumbLinks = [
    { linkUrl: "/company", linkName: `Company`, linkActive: false },
    { linkUrl: `/company/${companyId}/edit#basic`, linkName: companyName, linkActive: false },
    { linkUrl: `/company/${companyId}/edit#basic`, linkName: "Basic", linkActive: false },
    { linkUrl: ``, linkName: "Revenue", linkActive: true },
  ];

  const initialFormValues = {
    revenueYear: "",
    revenueAmount: "",
    revenueSourceUrl: "",
  };

  const formik = useFormik({
    initialValues: oldData || initialFormValues,
    validationSchema: Yup.object().shape(revenueValidationSchema),
    enableReinitialize: true,
  });

  const getCompanyName = async () => {
    if (companyId) {
      const fields = { fields: ["id", "companyName"] };
      const response = await fetchSingleCompany(companyId, { ...fields });
      setCompanyName(response.data.data.companyName);
    }
  };

  // save a revenue
  const handleSaveRevenue = async () => {
    formik.validateForm().then((res) => {
      if (Object.keys(res).length) {
        // console.log(res);
        const touched = {};
        Object.keys(res).map((field) => {
          touched[field] = true;
          return touched;
        });
        formik.setFormikState({ ...formik, touched: touched, errors: res });
      } else {
        dispatch(showLoader());
        let val = formik.values;
        const payload = {};
        payload.revenueYear = val.revenueYear;
        payload.revenueCurrency = "USD";
        payload.revenueAmount = val.revenueAmount == "NA" ? val.revenueAmount : +val.revenueAmount;
        payload.revenueSourceUrl = val.revenueSourceUrl;
        saveRevenue(companyId, payload)
          .then((response) => {
            dispatch(hideLoader());
            history.push(backPath);
            dispatch(actionSuccess("Revenue added successfully"));
          })
          .catch((err) => {
            dispatch(hideLoader());
            dispatch(actionError(err?.data?.message || "Something went wrong"));
          });
      }
    });
  };

  // handleEdit revenue
  const handleEditRevenue = async () => {
    formik.validateForm().then((res) => {
      if (Object.keys(res).length) {
        const touched = {};
        Object.keys(res).map((field) => {
          touched[field] = true;
          return touched;
        });
        formik.setFormikState({ ...formik, touched: touched, errors: res });
      } else {
        dispatch(showLoader());
        let val = formik.values;
        const payload = {};
        payload.revenueYear = val.revenueYear;
        payload.revenueAmount = val.revenueAmount == "NA" ? val.revenueAmount : +val.revenueAmount;
        payload.revenueSourceUrl = val.revenueSourceUrl;
        editRevenue(companyId, revenueId, payload)
          .then((response) => {
            dispatch(hideLoader());
            history.push(backPath);
            dispatch(actionSuccess("Revenue updated successfully"));
          })
          .catch((err) => {
            dispatch(hideLoader());
            dispatch(actionError(err.data ? err?.data?.message : "Something went wrong"));
          });
      }
    });
  };

  const setFormikValues = (data) => {
    const oldData = {
      revenueYear: data.revenueYear || "",
      revenueAmount: data.revenueAmount || "",
      revenueSourceUrl: data.revenueSourceUrl || "",
    };
    setOldData(oldData);
    setTimeout(() => {
      formik.setValues(oldData);
    }, 1);
  };

  useEffect(() => {
    if (props.editData && companyId && revenueId) {
      formik.resetForm();
      fetchSingleRevenue(companyId, revenueId)
        .then((res) => {
          const val = res?.data?.data?.companyRevenue;
          setFormikValues({ ...val });
        })
        .catch((err) => {
          dispatch(actionError(err?.data?.message || "Something went wrong"));
        });
    } else {
      formik.resetForm();
    }
  }, [props.editData, companyId, revenueId]);

  useEffect(() => {
    dispatch(setBreadCrumb(breadCrumbLinks));
  }, [breadCrumbLinks]);

  useEffect(() => {
    getCompanyName();
  }, [companyId]);

  return (
    <div className="p-0 m-3 company-basic-modal">
      <div className="modal-header">Company - Revenue</div>
      <div className="modal-body">
        <div className="row p-3">
          <div className="col-md-4">
            <div className="form-group">
              <TextField
                type="number"
                formik={formik}
                className="form-control"
                id="revenueYear"
                placeholder="Revenue Year *"
                name="revenueYear"
                ref={revenueYearRef}
              />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <TextField
                formik={formik}
                className="form-control"
                id="revenueAmount"
                placeholder="Revenue Amount (Million USD) *"
                name="revenueAmount"
              />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <TextField formik={formik} id="revenueSourceUrl" placeholder="Revenue Source URL *" name="revenueSourceUrl" />
            </div>
          </div>
        </div>

        <div className="text-right border-top p-3 mt-auto">
          <button
            type="button"
            onClick={(e) => {
              e.preventDefault();
              history.push(backPath);
            }}
            className="btn btn-outline-dark mr-3"
          >
            Cancel
          </button>

          {true ? (
            <button type="button" className="btn btn-primary" onClick={revenueId ? handleEditRevenue : handleSaveRevenue} disabled={false}>
              {revenueId ? "Update" : "Save"}
            </button>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default CompanyBasicRevenue;
